import React, { Component } from "react";
import {
  Form,
  Table,
  Select,
  Input,
} from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenericModal from "../../buttons/genericModal";
import Button from '@mui/material/Button';
import LoadingButton from "@mui/lab/LoadingButton";
import PermissionGate from "../../../helpers/PermissionGate";

const { Option } = Select;

class AdditionalEntityDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      submitting: false,
      additionalDetailsLength: Object.keys(this.props.additionalEntityData).length,
      formData: {},

      tableData: [],
      nextIndex: 0,
      tableIndices: [],
    };
  }
  formRef = React.createRef();

  componentDidMount = () => {
    var additionalDetailsLength = Object.keys(this.props.additionalEntityData).length;
    var newState = { ...this.state };
    var formData = {}, index = 0;
    for (var item in this.props.additionalEntityData) {
      formData['label' + String(index)] = item;
      formData['data' + String(index)] = this.props.additionalEntityData[item];
      index += 1
    }
    for (var i = 0; i < additionalDetailsLength; i++) {
      var newState = this.createNewRow({ ...newState });
    }
    newState['formData'] = formData;
    this.setState(newState);
  }


  onFormSubmitModal = (values) => {
    this.setState({ submitting: true });
    var additional_data = {};
    var indicies = this.state.tableIndices;
    for (var i = 0; i < indicies.length; i++) {
      additional_data[values["label" + indicies[i]]] = values["data" + indicies[i]];
    }
    var data = {
      'entity_id': this.props.entityId,
      'additional_data': additional_data
    }
    this.props.onSubmit(additional_data)
    backendPostWithoutRefresh("/api/entity/additional-details/", data)
      .then((response) => {
        this.setState({ visible: false, submitting: false });
        this.props.onChange(additional_data);
        if (this.formRef.current) {
          this.formRef.current.resetFields();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  createNewRow = (state) => {
    var index = state.nextIndex;
    const newRow = {
      key: index,
      label: <>
        <Form.Item
          style={{ marginTop: "20px" }}
          name={"label" + index}
          rules={[
            {
              required: true,
              message: "Please input an label name",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </>,
      data: <>
        <Form.Item
          style={{ marginTop: "20px" }}
          name={"data" + index}
          rules={[
            {
              required: true,
              message: "Please input value",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </>,
      deleteRow: <>
        <CloseCircleOutlined
          style={{ fontSize: "18px", color: "#787676", }}
          onClick={() => { this.removeRow(index); }}
        />
      </>
    };

    state['tableData'] = [...state.tableData, newRow];
    state['tableIndices'] = [...state.tableIndices, index];
    state['nextIndex'] = index + 1;

    return state;
  }

  removeRow = (index) => {
    // remove index from table indices
    var newTableDataIndices = [...this.state.tableIndices];
    var tableDataIndex = newTableDataIndices.indexOf(index);
    if (tableDataIndex > -1) {
      newTableDataIndices.splice(tableDataIndex, 1);
      this.setState({ tableIndices: newTableDataIndices });
    };
    // remove index from table data with key
    var newTableData = [...this.state.tableData];
    var i = 0;
    while (i < newTableData.length) {
      if (newTableData[i].key !== undefined && newTableData[i].key === index) {
        newTableData.splice(i, 1)
        this.setState({ tableData: newTableData });
        return;
      }
      i = i + 1;
    }
    // nothing to next index
    return;
  }

  render() {

    const columns = [
      {
        title: "Label",
        dataIndex: "label",
        width: "30%",
      },
      {
        title: "Data",
        dataIndex: "data",
        width: "40%",
      },
      {
        title: "",
        dataIndex: "deleteRow",
        width: "5%",
      },
    ];

    const modalBody = <>
      <div>
        <Form
          initialValues={this.state.formData}
          ref={this.formRef}
          layout="vertical"
          name="basic"
          onFinish={this.onFormSubmitModal}
          autoComplete="off"
        >

          <Button
            onClick={() => { this.setState(this.createNewRow({ ...this.state })) }}
            sx={{ marginBottom: 2, fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="primary"
          >
            Add a row
          </Button>

          <Table
            dataSource={this.state.tableData}
            columns={columns}
            pagination={false}
          />

          {/* Submit */}
          <Form.Item>
            <LoadingButton
              sx={{ marginTop: 2, fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
              loading={this.state.submitting} loadingPosition="start"
            >
              Submit
            </LoadingButton>
          </Form.Item>
        </Form>
      </div>
    </>;

    return (
      <PermissionGate
        requiredRole='dashboardEditor'
        toolTipText='Only admins and dashboard editors may add tags to entities'
        readOnly={
          <Button
            sx={{ fontSize: 12 }}
            size='small'
            variant='text'
            disabled
          >
            + Add Tags
          </Button>
        }
      >
      <GenericModal
        size="lg"
        visible={this.state.visible}
        handleCancelModal={() => this.setState({ ...this.state, visible: false })}
        showModal={() => this.setState({ ...this.state, visible: true })}
        button={<Button sx={{ fontSize: 12}}
          disableElevation fullWidth size="small" type="submit" variant="text" color="primary">
          + Add Tags
        </Button>}
        modalTitle={"Store Custom Entity Information"}
        modalBody={modalBody}
      />
      </PermissionGate>
    );
  }
}

export default AdditionalEntityDetails;
